export default "/logo-monash.png";